import locationService from './service.js'
import axios from 'axios'
import csp4Api from '../../api/csp4'
import {SERVICE} from '../../../helper/Constant.js'

export default {
  namespaced: true,
  state: {
    service: {
      pos: null,
      reconcile: null,
      commercial: null,
      csp4: null
    },
    location: {
      store: null,
      organization: null,
    },
    deals: [],
    order: [],
    Hardware: [],
    shipping: 10,
    Store: {
      businessName: null,
      phoneNumber: null,
      address: null,
      city: null,
      stateID: null,
      zipcode: null,
      country: null,
      businessEmail: null,
      invoiceEmail: null,
    },
    Card: {
      cardNumber: null,
      nameOnCard: null,
      cvvCode: null,
      cardExpiry: null,
      address: null,
      city: null,
      state: null,
      zipcode: null,
    },
    Plans: {
      selectedModules: [1],
      package: 2,
    },
    Review: {
      terms: false,
    },
  },
  getters: {
    service(state) {
      return state.service
    },
    location(state) {
      return state.location.store
    },
    organization(state) {
      return state.location.organization
    },
    shipping(state) {
      return state.shipping
    },
    hardwareTotal(state) {
      let amount = 0
        state.Hardware.forEach(row => {
          let value = row.order * row.amount
          amount = amount + value
        })
      if (amount !== 0) {
        if (amount <= 399) {
          amount = amount + 10
        }
      }
      return amount
    },
    hardware(state) {
      return state.Hardware
    },
    deals(state) {
      return state.deals
    },
    plans(state) {
      return state.Plans
    },
  },
  actions: {
    setReconcile({ commit }, payload) {
      commit('setReconcile', payload)
    },
    setPos({ commit }, payload) {
      commit('setPos', payload)
    },
    setCommercial({ commit }, payload) {
      commit('setCommercial', payload)
    },
    setCsp4({ commit }, payload) {
      commit('setCsp4', payload)
    },
    setLocation({ commit }, id) {
      return locationService.getbyId(id)
      .then(async (response) => {
        // console.log('response saqib', response)
        // if (response && response.metadata && !response.metadata.anydeskId) {
        //   response.metadata.
        // }
        commit('resetService')
        response.ProductRelations.map(x => {
          if (x.serviceID === 192) commit('setPos', x)
          if (x.serviceID === 193) commit('setReconcile', x)
          if (x.serviceID === 194) commit('setCommercial', x)
        })
        csp4Api.getLocationInfo(response.storeID)
        .then(csp4LocationInfo => {
          if (csp4LocationInfo) {
            commit('setCsp4', {
              serviceID: 198,
              csp4Info: csp4LocationInfo
            })
          }
        })
        .catch(error => {
          return null
        })
        // let csp4LocationInfo = await csp4Api.getLocationInfo(response.storeID)

        let latlong = null
        if(!response.latitude) {
          try {
            axios
            .get(`https://maps.googleapis.com/maps/api/geocode/json?address=${response.address} ${response.city}, ${response.State.stateSymbol} ${response.zipCode}&key=AIzaSyCaPgc55nqW_i4-RWWQQvycbuNjYqnloyY`)
            .then(result => {
              // console.log('address', result.data.results[0].geometry.location)
              latlong = {
                latitude: result.data.results[0].geometry.location.lat,
                longitude: result.data.results[0].geometry.location.lng,
              }
              let url = `https://maps.googleapis.com/maps/api/timezone/json?location=${latlong.latitude},${latlong.longitude}&timestamp=1458000000&key=AIzaSyCaPgc55nqW_i4-RWWQQvycbuNjYqnloyY`
              axios.get(url)
              .then(result => {
                latlong.timeZoneId = result.data.timeZoneId
                latlong.timeZoneName = result.data.timeZoneName
                return locationService.updateStore(response.storeID, latlong)
                .then(result => {
                  // console.log('set long lat', result)
                })
              })
            })

          } catch (error) {
            console.log('error on setting location', error)
          }
        }
        commit('setLocation', response)
        // commit('setOrganization', response.Organization)
        // console.log('setLocation response', response)
      })
    },
    setOrgPinNumber({ commit }, payload) {
      commit('setOrgPinNumber', payload)
    },
    setOrganization({ commit }, payload) {
      commit('setOrganization', payload)
    },
    addItem({ commit }, index) {
      commit('addItem', index)
    },
    removeItem({ commit }, index) {
      commit('removeItem', index)
    },
    // initHardware({ commit }) {
    //   return publicService.Hardware()
    //     .then((response) => {
    //       commit('initHardware', response.data)
    //     })
    // },
    loadDeals({ state, commit }) {
      let deals = []
      if (state.Plans.package === 1) {
        // 'Repair', 'BillPayment', 'TimeClock',
        deals = ['Repair', 'BillPayment', 'TimeClock', 'Hardware', 'Promotion']
        state.Plans.selectedModules.forEach(row => {
          console.log('row', row)
          if (row === 11) {
            var index = deals.indexOf('TimeClock');    // <-- Not supported in <IE9
            if (index !== -1) {
              deals.splice(index, 1);
            }
          }
          if (row === 3) {
            var index = deals.indexOf('BillPayment');    // <-- Not supported in <IE9
            if (index !== -1) {
              deals.splice(index, 1);
            }
          }
          if (row === 4) {
            var index = deals.indexOf('Repair');    // <-- Not supported in <IE9
            if (index !== -1) {
              deals.splice(index, 1);
            }
          }
        })
      } else {
        deals = ['Hardware', 'Promotion']
      }
      console.log('done', deals)
      commit('loadDeals', deals)
    },
    order({ commit }, payload) {
      commit('order', payload)
      commit('removeDeal')
    },
    removeDeal({ commit }) {
      commit('removeDeal')
    },
  },
  mutations: {
    resetService(state) {
      state.service.reconcile = null
      state.service.commercial = null
      state.service.pos = null
      state.service.csp4 = null
    },
    setReconcile(state, payload) {
      state.service.reconcile = payload
    },
    setCommercial(state, payload) {
      state.service.commercial = payload
    },
    setPos(state, payload) {
      state.service.pos = payload
    },
    setCsp4(state, payload) {
      state.service.csp4 = payload
    },
    setOrgPinNumber(state, payload) {
      state.location.organization.pinNumber = payload
    },
    setLocation(state, payload) {
      state.location.store = payload
    },
    setOrganization(state, payload) {
      state.location.organization = payload
    },
    addItem(state, index) {
      const oldOrder = state.Hardware[index].order
      state.Hardware[index].order = oldOrder + 1
    },
    removeItem(state, index) {
      const oldOrder = state.Hardware[index].order
      state.Hardware[index].order = oldOrder - 1
    },
    initHardware(state, payload) {
      payload.forEach(row => {
        row.order = 0
      })
      state.Hardware = payload
    },
    order(state, payload) {
      state.order.push(payload)
    },
    removeDeal(state) {
      state.deals.shift()
    },
    loadDeals(state, payload) {
      state.deals = payload
    },
  },
}
